import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createPrescription } from '../../../../apis/prescription'
import { resetPrescriptionsCache } from '../../../../shared'

/**
 * 処方箋作成（カメラ撮影）Mutation hook
 *
 * 画像をアップロードして処方箋を作成する。
 * 成功時は処方箋リストのキャッシュをリセットして再取得する。
 */
export const useCreatePrescriptionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (images: string[]) => createPrescription(images),
    onSuccess: () => resetPrescriptionsCache(queryClient),
  })
}
